import React from "react";
import IconButton from "../buttons/IconButton";
import pdfIcon from "../../assets/icons/pdfIcon.svg";
import eyeOpen from "../../assets/icons/eye-opened.svg";
import downloadIcon from "../../assets/icons/downloadIcon.svg";
import trashIcon from "../../assets/icons/trash.svg";
import styles from "./TemplateCards.module.css";
import Avatar from "../avatar/Avatar.jsx";

export const TEMPLATE_SUMMARY_BODY_COLUMNS =
  "90px minmax(24px,1fr) 160px minmax(24px,1fr) 75px minmax(24px,1fr) 70px minmax(24px,1fr) 69px minmax(24px,1fr) 180px";

function getClassName(...classNames) {
  return classNames.filter(Boolean).join(" ");
}

function Txt({ children, className }) {
  return <div className={getClassName(styles.text, className)}>{children}</div>;
}

function Tag({ children, color }) {
  return (
    <div className={styles.tag} style={color ? { background: color } : undefined}>
      <Txt className={styles.tagText}>{children}</Txt>
    </div>
  );
}

function ResponsableCell({ src, name }) {
  return (
    <div className={styles.avatar}>
      <Avatar src={src} name={name} size={24} />
      <Txt className={styles.avatarName}>{name}</Txt>
    </div>
  );
}

function Cell({ children, align = "left", className }) {
  const alignClassName = {
    left: styles.alignLeft,
    center: styles.alignCenter,
    right: styles.alignRight,
  }[align];

  return (
    <Txt className={getClassName(styles.cell, alignClassName, className)}>
      {children}
    </Txt>
  );
}

function RowShell({ children }) {
  return (
    <div className={styles.rowWrapper}>
      <div className={getClassName(styles.rowContent, styles.attachmentRowContent)}>
        {children}
      </div>
    </div>
  );
}

export function TemplateRowCard({
  template,
  brand,
  brandColor,
  files,
  ownerName,
  ownerAvatar,
  onAction,
  actionIcon,
  onRowClick,
}) {
  return (
    <div className={styles.rowWrapper}>
      <div
        className={styles.rowContent}
        onClick={onRowClick}
        onKeyDown={(event) => {
          if (!onRowClick) return;
          if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            onRowClick();
          }
        }}
        role={onRowClick ? "button" : undefined}
        tabIndex={onRowClick ? 0 : undefined}
        style={onRowClick ? { cursor: "pointer" } : undefined}
      >
        <Cell align="center" className={styles.templateCell}>
          {template}
        </Cell>

        <div className={styles.brandCell}>
          <Tag color={brandColor}>{brand}</Tag>
        </div>

        <Cell align="center" className={styles.filesCell}>
          {files}
        </Cell>

        <div className={styles.ownerCell}>
          <ResponsableCell src={ownerAvatar} name={ownerName} />
        </div>
      </div>

      <div className={styles.actionButtonWrapper}>
        <IconButton
          icon={actionIcon}
          size="md"
          iconSize={14}
          onClick={(event) => {
            event.stopPropagation();
            onAction?.();
          }}
          aria-label="Abrir template"
          className={styles.actionButton}
        />
      </div>
    </div>
  );
}

export function AttachmentRowCard({
  name,
  account,
  accountColor,
  size,
  onDownload,
  onShowFile,
  onDelete,
}) {
  const activateWithKeyboard = (action) => (event) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      event.stopPropagation();
      action?.();
    }
  };

  return (
    <RowShell>
      <Cell align="center" className={styles.attachmentIconCell}>
        <img src={pdfIcon} alt="" />
      </Cell>

      <Cell align="center" className={styles.attachmentNameCell}>
        {name}
      </Cell>

      {account && (
        <div className={styles.attachmentAccountCell}>
          <Tag color={accountColor}>{account}</Tag>
        </div>
      )}

      {size && (
        <Cell align="center" className={styles.attachmentSizeCell}>
          {size}
        </Cell>
      )}

      <div className={styles.attachmentActions}>
        <img
          src={eyeOpen}
          alt="Ver archivo"
          role="button"
          tabIndex={0}
          onClick={(event) => {
            event.stopPropagation();
            onShowFile?.();
          }}
          onKeyDown={activateWithKeyboard(onShowFile)}
          className={styles.clickableIcon}
        />

        <img
          src={downloadIcon}
          alt="Descargar"
          role="button"
          tabIndex={0}
          onClick={(event) => {
            event.stopPropagation();
            onDownload?.();
          }}
          onKeyDown={activateWithKeyboard(onDownload)}
          className={styles.clickableIcon}
        />

        <img
          src={trashIcon}
          alt="Eliminar"
          role="button"
          tabIndex={0}
          onClick={(event) => {
            event.stopPropagation();
            onDelete?.();
          }}
          onKeyDown={activateWithKeyboard(onDelete)}
          className={styles.deleteIcon}
        />
      </div>
    </RowShell>
  );
}
